const GET_BANNER_DETAILS = "GET_BANNER_DETAILS";
const GET_BANNER_DETAILS_SUCCESS = "GET_BANNER_DETAILS_SUCCESS";
const GET_BANNER_DETAILS_FAILURE = "GET_BANNER_DETAILS_FAILURE";
const CLEAR_GET_BANNER_DETAILS = "CLEAR_GET_BANNER_DETAILS";

const bannerDetailsSymbols = {
  GET_BANNER_DETAILS_SUCCESS,
  GET_BANNER_DETAILS_FAILURE,
  GET_BANNER_DETAILS,
  CLEAR_GET_BANNER_DETAILS,
};
export default bannerDetailsSymbols;
